/* tslint:disable */
/* eslint-disable */
/**
 * API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../../common/runtime';
import type { TimegateSettings } from './TimegateSettings';
import {
  TimegateSettingsFromJSON,
  TimegateSettingsFromJSONTyped,
  TimegateSettingsToJSON,
} from './TimegateSettings';

/**
 *
 * @export
 * @interface CampaignSettingsPatch
 */
export interface CampaignSettingsPatch {
  /**
   * Number of items (calls) to process in parallel per agent
   * @type {number}
   * @memberof CampaignSettingsPatch
   */
  agentMultiplier?: number;
  /**
   * Classification of the campaign, e.g. marketing
   * @type {string}
   * @memberof CampaignSettingsPatch
   */
  classification?: CampaignSettingsPatchClassificationEnum;
  /**
   * CustomIVR to play when a call is connected before the agent. References a CustomIvr from DP
   * @type {number | null}
   * @memberof CampaignSettingsPatch
   */
  customIvrDetailsId?: number | null;
  /**
   * Enable internal DNC/DNT checks for this campaign
   * @type {boolean}
   * @memberof CampaignSettingsPatch
   */
  enableInternalDnc?: boolean;
  /**
   * Enable national DNC/DNT checks for this campaign
   * @type {boolean}
   * @memberof CampaignSettingsPatch
   */
  enableNationalDnc?: boolean;
  /**
   * Business hours specification
   * @type {{ [key: string]: Array<Array<any>>; }}
   * @memberof CampaignSettingsPatch
   */
  hours?: { [key: string]: Array<Array<any>> };
  /**
   * max total calls to allow per item
   * @type {number}
   * @memberof CampaignSettingsPatch
   */
  maxCallAttempts?: number;
  /**
   * Playbook to use. References a playbook from DP
   * @type {number | null}
   * @memberof CampaignSettingsPatch
   */
  playbookId?: number | null;
  /**
   * Time zone enforcement settings
   * @type {TimegateSettings}
   * @memberof CampaignSettingsPatch
   */
  timegateSettings?: TimegateSettings;
  /**
   * Timezone mode to use for the timegate
   * @type {string}
   * @memberof CampaignSettingsPatch
   */
  timezoneMode?: CampaignSettingsPatchTimezoneModeEnum;
}

/**
 * @export
 */
export const CampaignSettingsPatchClassificationEnum = {
  Marketing: 'marketing',
  Informational: 'informational',
} as const;
export type CampaignSettingsPatchClassificationEnum =
  (typeof CampaignSettingsPatchClassificationEnum)[keyof typeof CampaignSettingsPatchClassificationEnum];

/**
 * @export
 */
export const CampaignSettingsPatchTimezoneModeEnum = {
  Phone: 'phone',
  Lead: 'lead',
  Address: 'address',
  AddressAndPhone: 'address_and_phone',
} as const;
export type CampaignSettingsPatchTimezoneModeEnum =
  (typeof CampaignSettingsPatchTimezoneModeEnum)[keyof typeof CampaignSettingsPatchTimezoneModeEnum];

/**
 * Check if a given object implements the CampaignSettingsPatch interface.
 */
export function instanceOfCampaignSettingsPatch(
  value: object,
): value is CampaignSettingsPatch {
  return true;
}

export function CampaignSettingsPatchFromJSON(
  json: any,
): CampaignSettingsPatch {
  return CampaignSettingsPatchFromJSONTyped(json, false);
}

export function CampaignSettingsPatchFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): CampaignSettingsPatch {
  if (json == null) {
    return json;
  }
  return {
    agentMultiplier:
      json['agent_multiplier'] == null ? undefined : json['agent_multiplier'],
    classification:
      json['classification'] == null ? undefined : json['classification'],
    customIvrDetailsId:
      json['custom_ivr_details_id'] == null
        ? undefined
        : json['custom_ivr_details_id'],
    enableInternalDnc:
      json['enable_internal_dnc'] == null
        ? undefined
        : json['enable_internal_dnc'],
    enableNationalDnc:
      json['enable_national_dnc'] == null
        ? undefined
        : json['enable_national_dnc'],
    hours: json['hours'] == null ? undefined : json['hours'],
    maxCallAttempts:
      json['max_call_attempts'] == null ? undefined : json['max_call_attempts'],
    playbookId: json['playbook_id'] == null ? undefined : json['playbook_id'],
    timegateSettings:
      json['timegate_settings'] == null
        ? undefined
        : TimegateSettingsFromJSON(json['timegate_settings']),
    timezoneMode:
      json['timezone_mode'] == null ? undefined : json['timezone_mode'],
  };
}

export function CampaignSettingsPatchToJSON(
  value?: CampaignSettingsPatch | null,
): any {
  if (value == null) {
    return value;
  }
  return {
    agent_multiplier: value['agentMultiplier'],
    classification: value['classification'],
    custom_ivr_details_id: value['customIvrDetailsId'],
    enable_internal_dnc: value['enableInternalDnc'],
    enable_national_dnc: value['enableNationalDnc'],
    hours: value['hours'],
    max_call_attempts: value['maxCallAttempts'],
    playbook_id: value['playbookId'],
    timegate_settings: TimegateSettingsToJSON(value['timegateSettings']),
    timezone_mode: value['timezoneMode'],
  };
}
